/* eslint-disable max-len */
import 'react';

const AddDocSvg = (): React.PropsWithoutRef<React.ReactSVGElement> => (
    <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
        <defs>
            <linearGradient x1="8.936%" y1="-3.267%" x2="88.281%" y2="97.811%" id="AddDocSvg_prefix__a">
                <stop stopColor="#62AFFF" offset="0%" />
                <stop stopColor="#37F" offset="100%" />
            </linearGradient>
        </defs>
        <g fill="none" fillRule="evenodd">
            <path d="M0 0h16v16H0z" />
            <path
                d="M4 1h6.509c.247 0 .485.09.67.255l3.587 3.188c.215.192.338.466.338.754v8.779a2 2 0 01-2 2H4a2 2 0 01-2-2V3a2 2 0 012-2z"
                fill="url(#AddDocSvg_prefix__a)"
            />
            <path
                d="M11.178 1.255l3.588 3.188c.106.095.19.21.248.337H11.66a.84.84 0 01-.84-.84V1.05c.132.042.254.112.358.205z"
                fill="#86BAFF"
            />
            <path
                d="M8.528 5.554a.75.75 0 01.75.75v1.5h1.5a.75.75 0 110 1.5H9.277l.001 1.5a.75.75 0 11-1.5 0l-.001-1.5H6.278a.75.75 0 010-1.5h1.5v-1.5a.75.75 0 01.75-.75z"
                fill="#FFF"
            />
        </g>
    </svg>
);
export default AddDocSvg;
